/**
 * Domain name duplicate alternatives found in top domains
 * Infrastructure tools are to be removed
 * Alternative domains are to be listed under main.
 */
export const titles = {
  "state.tx.us":"Texas State Government",
  "ufl.edu": "University of Florida",
  "admin.ch": " Swiss Government",
  "tufts.edu": "Tufts University",
"usgs.gov":  "U.S. Geological Survey",
  "theglobeandmail.com": "The Globe and Mail",
  "spiegel.de": "Spiegel German News",
  "justice.gov": "US Department of Justice",
  "gov.ru": "Russian Government",
  "martinfowler.com": "Martin Fowler",
  "optimizely.com": "Optimizely",
  "loc.gov": "Library of Congress",
  "uci.edu": "UC Irvine",
  "ca.gov": "California Government",
  "cam.ac.uk": "Cambridge University",
  "baidu.com": "Baidu",
  "tandfonline.com": "Taylor & Francis Journals",
  "ohchr.org": "UN Human Rights Office",
  "giphy.com": "Giphy",
  "naver.com": "Naver (네이버)",
  "upenn.edu": "University of Pennsylvania",
  "ft.com": "Financial Times",
  "berkeley.edu": "UC Berkeley",
  "kickstarter.com": "Kickstarter",
  "doi.org": "Digital Object Identifier",
  "stackoverflow.com": "StackOverflow",
  "businessinsider.com": "Business Insider",
  "ietf.org":  "Internet Engineering Task Force",
  "qq.com":"QQ (腾讯网)",
  "linktr.ee": "Link Tree",
  "vk.com": "VKontakte",
  "bit.ly": "Bitly",
  "europa.eu": "European Union",
  "newyorker.com": "New Yorker",
  "ameblo.jp": "Ameba Japanese",
  "gov.uk": "UK Government",
  "gov.ru": "Russian Government",
  "gov.ca": "Canadian Government",
  "gov.au": "Australian Government",
  "gov.nz": "New Zealand Government",
  "gov.in": "Indian Government",
  "gov.cn": "Chinese Government",
}


export const removals  = [
  { main: "polyfill.io", remove: true },
  { main: "example.com", remove: true },
  { main: "example.net", remove: true },
  { main: "domain.com", remove: true },
  { main: "jsdelivr.net", remove: true },
  { main: "gmpg.org", remove: true },
  { main: "aka.ms", remove: true },

  { main: "addthis.com", remove: true },
  { main: "doubleclick.net", remove: true },
  { main: "netdna-ssl.com", remove: true },
]
export const duplicates  = [
  {
    main: "godaddy.com",
    alt: ["wsimg.com"],
  },
  {
    main: "blogspot.com",
    alt: ["blogger.com", "blogspot.ca", "blogspot.co.uk"],
  },
  {
    main: "microsoft.com",
    alt: ["windows.net"],
  },
  {
    main: "huffingtonpost.com",
    alt: ["huffpost.com"],
  },
  {
    main: "sciencemag.org",
    alt: ["science.org"],
  },
  {
    main: "theguardian.com",
    alt: ["guardian.co.uk"],
  },
  {
    main: "bootstrap.com",
    alt: ["bootstrapcdn.com"],
  },
  {
    main: "telegram.me",
    alt: ["telegram.org", "telegra.ph", "t.me"],
  },
  {
    main: "netlify.com",
    alt: ["netlify.app"],
  },
  {
    main: "apple.com",
    alt: ["apple.co"],
  },
  {
    main: "pinterest.com",
    alt: ["pinterest.co.uk", "pinimg.com"],
  },
  {
    main: "bbc.co.uk",
    alt: ["bbci.co.uk", "bbc.com"],
  },
  {
    main: "yandex.ru",
    alt: ["yandex.net"],
  },
  {
    main: "pewresearch.org",
    alt: ["pewsocialtrends.org"],
  },
  {
    main: "jenkins.io",
    alt: ["jenkins-ci.org"],
  },
  {
    main: "wix.com",
    alt: ["wixstatic.com", "wixsite.com"],
  },
  {
    main: "wordpress.com",
    alt: ["wp.me", "wordpress.org", "wp.com", "w.org", "gravatar.com", "wpengine.com"],
  },
  {
    main: "amazon.com",
    alt: [
      "amazon.es",
        "amazon.in",
        "amazon.it",
        "amazon.de",
        "amazon.fr",
      "alexa.com",
      "amazon.cn",
      "amazon.co.jp",
      "amazon.com.au",
      "amazon.com.br",
      "amazon.com.cn",
      "amazon.com.hk",
      "amazon.com.mx",
      "amazon.com.sg",
      "amazon.com.tw",
      "amazon.com.mx",
      "cloudfront.net",
      "amzn.to",
      "a.co",
      "amazon.fr",
      "amazon.de",
      "amazon.co.uk",
      "amazonaws.com",
      "media-amazon.com",
    ],
  },
  {
    main: "mailchimp.com",
    alt: ["mailchi.mp", "list-manage.com", "eepurl.com"],
  },
  {
    main: "flickr.com",
    alt: ["staticflickr.com"],
  },
  {
    main: "facebook.com",
    alt: ["fb.watch", "facebook.net", "fb.me", "fb.com", "fbcdn.net"],
  },
  {
    main: "whatapp.com",
    alt: ["wa.me"],
  },
  {
    main: "thetimes.com",
    alt: ["timesonline.co.uk", "thetimes.co.uk"],
  },
  {
    main: "youtube.com",
    alt: ["youtu.be", "youtube-nocookie.com", "ytimg.com"],
  },
  {
    main: "imgbb.com",
    alt: ["ibb.com", "ibb.co"],
  },
  {
    main: "x.com",
    alt: ["twitter.com", "t.co", "twimg.com"],
  },
  {
    main: "npmjs.com",
    alt: ["unpkg.com"],
  },
  {
    main: "github.com",
    alt: ["githubusercontent.com", "github.io", "git-scm.com"],
  },
  {
    main: "google.com",
    alt: [
      "googleapis.com",
      "g.page",
      "business.site",
      "google-analytics.com",
      "goo.gl",
      "withgoogle.com",
      "ggpht.com",
      "research.google",
      "g.co",
      "translate.goog",
      "googleblog.com",
      "blog.google",
      "forms.gle",
      "googletagmanager.com",
      "googleadservices.com",
      "googleusercontent.com",
      "googlesyndication.com",
      "gstatic.com",
      "google.ad",
      "google.ae",
      "google.com.af",
      "google.com.ag",
      "google.al",
      "google.am",
      "google.co.ao",
      "google.com.ar",
      "google.as",
      "google.at",
      "google.com.au",
      "google.az",
      "google.ba",
      "google.com.bd",
      "google.be",
      "google.bf",
      "google.bg",
      "google.com.bh",
      "google.bi",
      "google.bj",
      "google.com.bn",
      "google.com.bo",
      "google.com.br",
      "google.bs",
      "google.bt",
      "google.co.bw",
      "google.by",
      "google.com.bz",
      "google.ca",
      "google.cd",
      "google.cf",
      "google.cg",
      "google.ch",
      "google.ci",
      "google.co.ck",
      "google.cl",
      "google.cm",
      "google.cn",
      "google.com.co",
      "google.co.cr",
      "google.com.cu",
      "google.cv",
      "google.com.cy",
      "google.cz",
      "google.de",
      "google.dj",
      "google.dk",
      "google.dm",
      "google.com.do",
      "google.dz",
      "google.com.ec",
      "google.ee",
      "google.com.eg",
      "google.es",
      "google.com.et",
      "google.fi",
      "google.com.fj",
      "google.fm",
      "google.fr",
      "google.ga",
      "google.ge",
      "google.gg",
      "google.com.gh",
      "google.com.gi",
      "google.gl",
      "google.gm",
      "google.gr",
      "google.com.gt",
      "google.gy",
      "google.com.hk",
      "google.hn",
      "google.hr",
      "google.ht",
      "google.hu",
      "google.co.id",
      "google.ie",
      "google.co.il",
      "google.im",
      "google.co.in",
      "google.iq",
      "google.is",
      "google.it",
      "google.je",
      "google.com.jm",
      "google.jo",
      "google.co.jp",
      "google.co.ke",
      "google.com.kh",
      "google.ki",
      "google.kg",
      "google.co.kr",
      "google.com.kw",
      "google.kz",
      "google.la",
      "google.com.lb",
      "google.li",
      "google.lk",
      "google.co.ls",
      "google.lt",
      "google.lu",
      "google.lv",
      "google.com.ly",
      "google.co.ma",
      "google.md",
      "google.me",
      "google.mg",
      "google.mk",
      "google.ml",
      "google.com.mm",
      "google.mn",
      "google.com.mt",
      "google.mu",
      "google.mv",
      "google.mw",
      "google.com.mx",
      "google.com.my",
      "google.co.mz",
      "google.com.na",
      "google.com.ng",
      "google.com.ni",
      "google.ne",
      "google.nl",
      "google.no",
      "google.com.np",
      "google.nr",
      "google.nu",
      "google.co.nz",
      "google.com.om",
      "google.com.pa",
      "google.com.pe",
      "google.com.pg",
      "google.com.ph",
      "google.com.pk",
      "google.pl",
      "google.pn",
      "google.com.pr",
      "google.ps",
      "google.pt",
      "google.com.py",
      "google.com.qa",
      "google.ro",
      "google.ru",
      "google.rw",
      "google.com.sa",
      "google.com.sb",
      "google.sc",
      "google.se",
      "google.com.sg",
      "google.sh",
      "google.si",
      "google.sk",
      "google.com.sl",
      "google.sn",
      "google.so",
      "google.sm",
      "google.sr",
      "google.st",
      "google.com.sv",
      "google.td",
      "google.tg",
      "google.co.th",
      "google.com.tj",
      "google.tl",
      "google.tm",
      "google.tn",
      "google.to",
      "google.com.tr",
      "google.tt",
      "googlesource.com",
      "google.com.tw",
      "google.co.tz",
      "google.com.ua",
      "google.co.ug",
      "google.co.uk",
      "google.com.uy",
      "google.co.uz",
      "google.com.vc",
      "google.co.ve",
      "google.co.vi",
      "google.com.vn",
      "google.vu",
      "google.ws",
      "google.rs",
      "google.co.za",
      "google.co.zm",
      "google.co.zw",
      "google.cat",
    ],
  },
];
